import { ButtonHTMLAttributes } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconProp;
  isLoading?: boolean;
};

export function IconButton(props: IconButtonProps) {
  const { icon, isLoading, ...rest } = props;
  return (
    <button type="button" className="btn border p-1 py-2 lh-sm" {...rest}>
      <FontAwesomeIcon icon={icon} size="lg" fade={isLoading} fixedWidth />
    </button>
  );
}
